
import LinkedAccountList from './linked-account-list.component';
import ComponentsModule from 'app/components/components.module';

angular.module(
  'linkedAccounts',
  [ 'accountViewServices', ComponentsModule.moduleName ]
).component('linkedAccountList', LinkedAccountList);

export const moduleName = 'linkedAccounts';
export default {
  moduleName,
};